/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {enumPolicies, enumSystemPolicyType} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import PolicyChecker from '../../../../helpers/components/PolicyChecker';
import { SystemPolicyChecker } from '../../../../helpers/components/SystemPolicyChecker';
import { useAuth } from '../../../../../app/modules/auth'
import { TENANT_RESET_PATH, isPlatformOwner } from '../../../../../app/pages/setting/tenantResetUtils'

const SidebarMenuMain = () => {
    const intl = useIntl()
    const {currentUser} = useAuth()

    return (
        <>
            {/* <SidebarMenuItem
                to='/dashboard'
                icon='element-11'
                title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
                fontIcon='bi-app-indicator'
            /> */}

            <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                        {intl.formatMessage({id: 'MENU.PAGES'})}
                    </span>
                </div>
            </div>

            <PolicyChecker policies={[enumPolicies.OrderCheckoutEdit, enumPolicies.OrderCheckoutRead, enumPolicies.OrderCheckoutWrite]}>
                <SidebarMenuItem to='/checkout-management/checkout' icon='handcart' title={intl.formatMessage({id: 'CHECKOUT.MANAGEMENT.BREADCRUMB.CHECKOUT_TITLE'})} />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.OrderRead, enumPolicies.OrderWrite, enumPolicies.OrderEdit]}>
                <SidebarMenuItem to='/order-management/orders' icon='delivery-2' title={intl.formatMessage({id: 'ORDER.MANAGEMENT.ORDER_TITLE'})} />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.InvoiceEdit, enumPolicies.InvoiceRead, enumPolicies.InvoiceWrite]}>
                <SidebarMenuItem to='/order-management/invoices' icon='document' title={intl.formatMessage({id: 'ORDER.MANAGEMENT.INVOICE_TITLE'})} />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.QuoteRead, enumPolicies.QuoteEdit, enumPolicies.QuoteWrite]}>
                <SidebarMenuItem to='/order-management/quotes' icon='document' title={intl.formatMessage({id: 'ORDER.MANAGEMENT.QUOTE_TITLE'})} />
            </PolicyChecker>

            <SystemPolicyChecker policyId={enumSystemPolicyType.StockControl}>
                <PolicyChecker policies={[enumPolicies.StockRead, enumPolicies.StockEdit, enumPolicies.StockWrite]}>
                    <SidebarMenuItem to='/stock-management/stocks' icon='dropbox' title={intl.formatMessage({id: 'STOCK.MANAGEMENT.STOCKS_TITLE'})} />
                </PolicyChecker>
            </SystemPolicyChecker>

            <PolicyChecker policies={[enumPolicies.ManufacturedProductRead]}>
                <SidebarMenuItem to='/production-management/productions' icon='element-11' title={intl.formatMessage({id: 'PRODUCTION.MANAGEMENT.PRODUCTION_TITLE'})} />
            </PolicyChecker>

            <div className='menu-item'>
                <div className='menu-content pt-4'></div>
            </div>

            <PolicyChecker
                policies={[
                    enumPolicies.UserWrite,
                    enumPolicies.UserEdit,
                    enumPolicies.UserDealerRead,
                    enumPolicies.CustomerRead,
                    enumPolicies.CustomerEdit,
                    enumPolicies.CustomerWrite,
                    enumPolicies.ProductRead,
                    enumPolicies.ProductEdit,
                    enumPolicies.ProductWrite,
                    enumPolicies.ProductPriceRead,
                ]}
            >
                <SidebarMenuItem to='/user-management' icon='profile-user' title={intl.formatMessage({id: 'USER.MANAGEMENT.USER_TITLE'})} activeUrls={['/customer-management']} />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.ProductRead, enumPolicies.ProductEdit, enumPolicies.ProductWrite]}>
                <SidebarMenuItem to='/catalog-management/products' icon='basket' title={intl.formatMessage({id: 'CATALOG.MANAGEMENT.PRODUCT_TITLE'})} />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.PriceRead, enumPolicies.PriceEdit]}>
                <SidebarMenuItem to='/price-management' icon='euro' title='Price' />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.DiscountRead, enumPolicies.DiscountEdit, enumPolicies.DiscountWrite]}>
                <SidebarMenuItem to='/order-management/discounts' icon='percentage' title={intl.formatMessage({id: 'ORDER.MANAGEMENT.DISCOUNT_TITLE'})} />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.AdsLeadEdit]}>
                <SidebarMenuItem to='/lead-management/leads' icon='chart-line' title={intl.formatMessage({id: 'LEAD.MANAGEMENT.LEADS'})} />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.DevSupportEdit, enumPolicies.DevSupportRead, enumPolicies.DevSupportWrite]}>
                <SidebarMenuItem to='/dev-support/tickets' icon='support-24' title={intl.formatMessage({id: 'DEV.SUPPORT.TICKETS_TITLE'})} />
            </PolicyChecker>

            <PolicyChecker policies={[enumPolicies.Settings, enumPolicies.SystemSettingsRead, enumPolicies.SystemSettingsWrite]}>
                <SidebarMenuItemWithSub
                    to='/settings'
                    icon='gear'
                    title={intl.formatMessage({id: 'MENU.SETTINGS'})}
                    fontIcon='bi-layers'
                >
                    {/* <SystemPolicyChecker policyId={enumSystemPolicyType.StockControl}>
                        <PolicyChecker policies={[enumPolicies.StockRead, enumPolicies.StockEdit, enumPolicies.StockWrite]}>
                            <SidebarMenuItem to='/stock-management/stocks-operation' title={intl.formatMessage({id: 'STOCK.MANAGEMENT.ADD_DROP_STOCKS_TITLE'})} hasBullet={true}/>
                            <SidebarMenuItem to='/stock-management/stocks-print' title={intl.formatMessage({id: 'STOCK.MANAGEMENT.PRINT_TITLE'})} hasBullet={true}/>
                        </PolicyChecker>
                    </SystemPolicyChecker> */}

                    {/* <PolicyChecker policies={[enumPolicies.OrderCheckoutEdit, enumPolicies.OrderCheckoutRead, enumPolicies.OrderCheckoutWrite]}>
                        <SidebarMenuItem to='/checkout-management/cart' title={intl.formatMessage({id: 'CHECKOUT.MANAGEMENT.BREADCRUMB.SUMMARY_TITLE'})} hasBullet={true}/>
                    </PolicyChecker> */}

                    <PolicyChecker policies={[enumPolicies.Settings]}>
                        <SidebarMenuItem to='/catalog-management/categories' title={intl.formatMessage({id: 'CATALOG.MANAGEMENT.CATEGORY_TITLE'})} hasBullet={true}/>
                        <SidebarMenuItem to='/localization/contents' title={intl.formatMessage({id: 'LOCALIZATION.CONTENT_TITLE'})} hasBullet={true}/>
                        <SidebarMenuItem to='/localization/resources' title={intl.formatMessage({id: 'LOCALIZATION.RESOURCES_TITLE'})} hasBullet={true}/>
                    </PolicyChecker>
                    <PolicyChecker policies={[enumPolicies.SystemSettingsRead, enumPolicies.SystemSettingsWrite]}>
                        <SidebarMenuItem to='/setting-management/company' title={intl.formatMessage({id: 'SETTING.COMPANY_TITLE'})} hasBullet={true}/>
                        <SidebarMenuItem to='/setting-management/invoice' title={intl.formatMessage({id: 'SETTING.INVOICE_TITLE'})} hasBullet={true}/>
                        <SidebarMenuItem to='/setting-management/quotation' title={intl.formatMessage({id: 'SETTING.QUOTATION_TITLE'})} hasBullet={true}/>
                        <SidebarMenuItem to='/setting-management/document-texts' title={intl.formatMessage({id: 'SETTING.DOCUMENT_TEXTS_TITLE'})} hasBullet={true}/>
                        <SidebarMenuItem to='/setting-management/email' title={intl.formatMessage({id: 'SETTING.SMTP_TITLE'})} hasBullet={true}/>
                        <SidebarMenuItem to='/setting-management/notification-template' title={intl.formatMessage({id: 'SETTING.NOTIFICATION_TEMPLATE_TITLE'})} hasBullet={true}/>
                        <SidebarMenuItem to='/setting-management/notification-subscriptions' title={intl.formatMessage({id: 'SETTING.NOTIFICATION_SUBSCRIPTION_TITLE'})} hasBullet={true}/>
                    </PolicyChecker>
                    {/* The platform owner only, whatever the account's policies (ADR-0058). */}
                    {isPlatformOwner(currentUser) && (
                        <SidebarMenuItem to={TENANT_RESET_PATH} title={intl.formatMessage({id: 'SETTING.TENANT_RESET_TITLE'})} hasBullet={true}/>
                    )}
                </SidebarMenuItemWithSub>
            </PolicyChecker>
        </>
    )
}

export {SidebarMenuMain}
